module.exports = __webpack_public_path__ + "img/roundup_grey.e367c71b.svg";